module.exports = __webpack_public_path__ + "img/partner11.882f1942.png";